
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TreeFiltersRangeRow extends Vue {
  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: String, default: "from" })
  readonly fromLabel!: string;

  @Prop({ type: String, default: "until" })
  readonly toLabel!: string;
}
